'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



// WEBPACK FOOTER //
// /Users/jinxuanzhu/.nvm/versions/node/v8.4.0/lib/node_modules/unified/node_modules/bail/index.js